import { defineComponent as K, useTemplateRef as P, computed as R, toRefs as E, getCurrentInstance as U, createElementBlock as V, openBlock as s, mergeProps as c, unref as e, createElementVNode as A, createCommentVNode as d, normalizeClass as F, createBlock as B, withCtx as N, renderSlot as z } from "vue";
import { useChildrenTracker as C } from "../use/children-tracker.js";
import n from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/FormControl/form-control.js";
import { useInputValidation as D } from "../input.js";
import { FormInputsKey as G, FormGroupInputsKey as L } from "./Form/common.js";
import { useOUIAProps as M } from "../helpers/ouia.js";
import g from "./FormControlIcon.vue2.js";
const j = ["value", "type", "aria-invalid", "disabled", "readonly"], Z = /* @__PURE__ */ K({
  name: "PfTextInput",
  inheritAttrs: !1,
  __name: "TextInput",
  props: {
    disabled: { type: Boolean },
    expanded: { type: Boolean },
    readonly: { type: Boolean },
    readOnlyVariant: {},
    validated: {},
    type: { default: "text" },
    modelValue: { default: void 0 },
    modelModifiers: {},
    ariaLabel: {},
    startTruncated: { type: Boolean },
    autoValidate: { type: [String, Boolean], default: !0 },
    noStatusIcon: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["change", "blur", "input", "invalid", "keyup", "update:modelValue", "update:validated"],
  setup(b, { expose: k }) {
    var I;
    const i = b, S = M({ id: i.ouiaId, safe: i.ouiaSafe }), l = P("inputRef"), u = R(() => !i.noStatusIcon && ["success", "error", "warning"].includes(r.value)), { validated: $ } = E(i), {
      value: p,
      effectiveValidated: r,
      onBlur: m,
      onChange: f,
      onInput: O,
      onInvalid: y,
      onKeyUp: v,
      ...T
    } = D({
      inputElement: l,
      autoValidate: i.autoValidate,
      validated: $
    });
    C(G, (I = U()) == null ? void 0 : I.proxy), C(L, r);
    function w() {
      var o;
      (o = l.value) == null || o.focus();
    }
    return k({
      ...T,
      input: l,
      focus: w,
      value: p,
      effectiveValidated: r
    }), (o, a) => (s(), V("span", c(e(S), {
      class: [
        e(n).formControl,
        {
          [e(n).modifiers.readonly]: !!o.readOnlyVariant,
          [e(n).modifiers.plain]: o.readOnlyVariant === "plain",
          [e(n).modifiers.success]: e(r) === "success",
          [e(n).modifiers.warning]: e(r) === "warning",
          [e(n).modifiers.error]: e(r) === "error",
          [e(n).modifiers.icon]: !!o.$slots.icon,
          [e(n).modifiers.disabled]: o.disabled,
          [e(n).modifiers.expanded]: o.expanded
        }
      ]
    }), [
      A("input", c(o.$attrs, {
        ref: "inputRef",
        value: e(p),
        type: o.type,
        "aria-invalid": e(r) === "error",
        disabled: o.disabled || void 0,
        readonly: !!o.readOnlyVariant || o.readonly,
        onChange: a[0] || (a[0] = //@ts-ignore
        (...t) => e(f) && e(f)(...t)),
        onInput: a[1] || (a[1] = (t) => e(O)(t)),
        onBlur: a[2] || (a[2] = //@ts-ignore
        (...t) => e(m) && e(m)(...t)),
        onInvalid: a[3] || (a[3] = //@ts-ignore
        (...t) => e(y) && e(y)(...t)),
        onKeyup: a[4] || (a[4] = //@ts-ignore
        (...t) => e(v) && e(v)(...t))
      }), null, 16, j),
      o.$slots.icon || u.value ? (s(), V("span", {
        key: 0,
        class: F(e(n).formControlUtilities)
      }, [
        o.$slots.icon ? (s(), B(g, { key: 0 }, {
          default: N(() => [
            z(o.$slots, "icon")
          ]),
          _: 3
        })) : d("", !0),
        u.value ? (s(), B(g, {
          key: 1,
          status: e(r)
        }, null, 8, ["status"])) : d("", !0)
      ], 2)) : d("", !0)
    ], 16));
  }
});
export {
  Z as default
};
